import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Typography,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Box,
  Button,
  Collapse
} from '@mui/material';

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedOrders, setExpandedOrders] = useState({});

  useEffect(() => {
  const userStr = localStorage.getItem('user');
  if (!userStr) {
    setError('Inloggad användare saknas.');
    setLoading(false);
    return;
  }

  const user = JSON.parse(userStr);
  if (!user.userId) {
    setError('Ogiltig användardata.');
    setLoading(false);
    return;
  }

  const fetchOrders = async () => {
    try {
      const apiBaseUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";
      const response = await axios.get(`${apiBaseUrl}/api/orders/${user.userId}`);
   // Filtrera bort alla orders som inte är "Paid"
const paidOrders = (response.data || []).filter(order => order.status === "Paid");
setOrders(paidOrders);

    } catch (err) {
      console.error('Error fetching orders:', err);
      setError('Något gick fel när vi hämtade dina beställningar.');
    } finally {
      setLoading(false);
    }
  };

  fetchOrders();
}, []);

  const toggleExpand = (orderId) => {
    setExpandedOrders((prev) => ({
      ...prev,
      [orderId]: !prev[orderId],
    }));
  };

  if (loading) return <div>Laddar beställningar...</div>;
  if (error) return <div>{error}</div>;

  return (
    <Box sx={{ padding: 2, paddingBottom: '120px' }}>
      <Typography variant="h4" gutterBottom align="center">
        Orderhistorik
      </Typography>

      {orders.length === 0 ? (
  <Typography align="center" sx={{ marginTop: 4 }}>
    Inga beställningar
  </Typography>
) : (
  <Grid container spacing={2}>
    {/* rendera orders */}
  </Grid>
)}


      <Grid container spacing={2}>
        {orders.map((order) => {

          // beräkna frakt från total_amount
          const itemsTotal = order.items.reduce(
            (sum, item) => sum + item.price * item.quantity,
            0
          );
          const shippingPrice = order.total_amount - itemsTotal;

          return (
            <Grid item xs={12} md={6} lg={4} key={order._id}>
              <Card sx={{ padding: 1, height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardContent>
                  <Typography variant="h6">Order-ID: {order._id}</Typography>
                  <Typography variant="body2">Total: {order.total_amount} SEK</Typography>

                  <Box sx={{ marginTop: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                    {Array.isArray(order.items) && order.items.length > 0 ? (
                      order.items.map((item, idx) => (
                        <Box key={item._id || idx} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                          <CardMedia
                            component="img"
                            image={item.thumbnail_url || item.designFileUrl || '/placeholder.jpg'}
                            alt={item.name}
                            sx={{ width: 60, height: 60, objectFit: 'cover' }}
                          />
                          <Typography variant="subtitle1">{item.name}</Typography>
                        </Box>
                      ))
                    ) : (
                      <Typography>Inga produkter i denna order</Typography>
                    )}
                  </Box>

                  <Button
                    size="small"
                    sx={{ marginTop: 1 }}
                    onClick={() => toggleExpand(order._id)}
                  >
                    {expandedOrders[order._id] ? 'Visa mindre' : 'Mer info'}
                  </Button>

                  <Collapse in={expandedOrders[order._id]}>
                    <Box sx={{ marginTop: 1 }}>

                      <Typography variant="body2" sx={{ marginBottom: 2 }}>
                        Beställningsdatum: {order.created_at ? new Date(order.created_at).toLocaleDateString("sv-SE") : "Okänt"}
                      </Typography>

                      {order.items.map((item, idx) => (
                        <Card key={item._id || idx} sx={{ padding: 1, marginBottom: 1 }}>
                          <CardContent>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{item.name}</Typography>
                            <Typography variant="body2">Storlek: {item.size}</Typography>
                            <Typography variant="body2">Färg: {item.color}</Typography>
                            <Typography variant="body2">Antal: {item.quantity}</Typography>

                            <Typography variant="body2">
                              Pris/st (inkl. moms): {item.price} SEK
                            </Typography>

                            <Typography variant="body1" sx={{ fontWeight: 'bold', marginTop: 1 }}>
                              Totalt: {item.price * item.quantity} SEK
                            </Typography>
                          </CardContent>
                        </Card>
                      ))}

                      {/* --- Fraktpris (uträknat) --- */}
                      <Typography variant="body2" sx={{ marginBottom: 1 }}>
                        Frakt: {shippingPrice} SEK
                      </Typography>

                      {/* --- Ordertotal --- */}
                      <Typography variant="h6" sx={{ marginTop: 2, fontWeight: "bold" }}>
                        Ordertotal: {order.total_amount} SEK
                      </Typography>

                    </Box>
                  </Collapse>

                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Orders;
